// This file adds event listeners for Turbo Frame loads to reinitialize JavaScript functionality

document.addEventListener('turbo:frame-render', function(event) {
  const frame = event.target;

  // Reinitialize sortable lists
  if (window.Sortable) {
    frame.querySelectorAll('[data-toggle="sortable"]').forEach(function(selector) {
      const options = {};
      
      // Copy all data attributes to options
      Object.keys(selector.dataset).forEach(key => {
        options[key] = selector.dataset[key];
      });
      
      options.animation = options.animation || 150;
      options.filter = options.filter || '.ignore-sort';
      
      if (options.onSortUrl) {
        options.onSort = function(evt) {
          const elements = selector.querySelectorAll('[data-id]');
          if (elements.length === 0) return;
          
          const ids = [];
          elements.forEach(function(element) {
            ids.push(element.dataset.id);
          });
          
          // Get the CSRF token from the meta tag
          const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
          
          // Determine if we're in a Turbo Frame
          const frame = selector.closest('turbo-frame');
          const frameId = frame ? frame.id : null;
          
          // Use fetch API instead of jQuery
          fetch(options.onSortUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken,
              'Accept': 'application/json'
            },
            body: JSON.stringify({ ids: ids })
          })
          .then(response => {
            if (response.ok) {
              toastr.success('Changes saved successfully', { timeOut: 5000 });
              // No need to manually update the frame - the controller will handle it
            } else {
              throw new Error('Network response was not ok');
            }
          })
          .catch(error => {
            toastr.error('Unable to save changes. Please, try again.', { timeOut: 0 });
            console.error('Error:', error);
          });
        };
      }
      
      new window.Sortable(selector, options);
    });
  }
  
  // Reinitialize dropzone
  if (window.Dropzone) {
    window.Dropzone.autoDiscover = false;
    frame.querySelectorAll('.fileinput-dropzone:not(.dz-clickable)').forEach(function(element) {
      const defaultMessage = element.dataset.defaultMessage;
      const appendToSelector = element.dataset.appendTo;
      const appendTo = document.querySelector(appendToSelector);
      
      const dropzone = new window.Dropzone(element, { dictDefaultMessage: defaultMessage });
      dropzone.on("success", function(file, data) {
        dropzone.removeFile(file);
        if (appendTo) {
          appendTo.insertAdjacentHTML('beforeend', data.html);
        }
      });
    });
  }
});
